import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import React from "react";
import { MdAddBox } from "react-icons/md";
import LocationStockList from "./LocationStockList";
import { useSelector } from "react-redux";
import LocationStockInward from "../operations/LocationStockInward";

const LocationStockManagement = () => {
  const inventorySettings = useSelector(
    (state) => state.inventorySettings.data
  );
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <>
      {roles.any(["location_admin"]) &&
      inventorySettings.stock_level === "location" ? (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Location stock"
            viewIcon={<FactoryIcon />}
            createIcon={<MdAddBox />}
            createChildren={<LocationStockInward/>}
            listChildren={<LocationStockList />}
          />
        </Box>
      ) : (
        <LocationStockList />
      )}
    </>
  );
};

export default LocationStockManagement;
